import { ContactFormField } from '../../types';

export const contactFields: ContactFormField[] = [
  {
    name: 'user_name',
    labelKey: 'contact.form.name',
    type: 'text',
    placeholderKey: 'contact.form.namePlaceholder',
    required: true,
  },
  {
    name: 'user_email',
    labelKey: 'contact.form.email',
    type: 'email',
    placeholderKey: 'contact.form.emailPlaceholder',
    required: true,
    validation: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
  },
  {
    name: 'user_phone',
    labelKey: 'contact.form.phone',
    type: 'tel',
    placeholderKey: 'contact.form.phonePlaceholder',
    required: false,
  },
  {
    name: 'subject',
    labelKey: 'contact.form.subject',
    type: 'select',
    required: true,
    options: [
      { value: '', labelKey: 'contact.form.subjectPlaceholder' },
      { value: 'rehab', labelKey: 'services.rehab.name' },
      { value: 'menhely', labelKey: 'services.menhely.name' },
      { value: 'gazdi', labelKey: 'services.gazdi.name' },
      { value: 'general', labelKey: 'contact.form.subjectGeneral' },
    ],
  },
  {
    name: 'message',
    labelKey: 'contact.form.message',
    type: 'textarea',
    placeholderKey: 'contact.form.messagePlaceholder',
    required: true,
  },
  {
    name: 'attachment',
    labelKey: 'contact.form.attachment',
    type: 'file',
    required: false,
    accept: 'image/*,.pdf,.doc,.docx',
  },
];
